import axiosClient from '../axiosClient';

export interface WorkspaceInviteMetadata {
  workspaceId: string;
  invitedBy?: string;
  boardId?: number | string | null;
  boardName?: string | null;
  token?: string;
}

export interface Notification {
  id: string;
  userId: string;
  type: string;
  title: string;
  message: string;
  // Matches the backend entity's `metadata` column - was previously typed
  // as `data`, a field the API never actually returns.
  metadata?: WorkspaceInviteMetadata | Record<string, unknown> | null;
  isRead: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationsResponse {
  notifications: Notification[];
  total: number;
  unreadCount: number;
}

export const notificationsApi = {
  // Get notifications
  getNotifications: async (params?: {
    limit?: number;
    offset?: number;
    unreadOnly?: boolean;
  }): Promise<NotificationsResponse> => {
    const response = await axiosClient.get('/notifications', { params });
    return response.data;
  },

  // Get unread count
  getUnreadCount: async (): Promise<{ count: number }> => {
    const response = await axiosClient.get('/notifications/unread-count');
    return response.data;
  },

  // Mark notification as read
  markAsRead: async (notificationId: string): Promise<Notification> => {
    const response = await axiosClient.post(`/notifications/${notificationId}/read`);
    return response.data;
  },

  // Mark all as read
  markAllAsRead: async (): Promise<void> => {
    await axiosClient.post('/notifications/read-all');
  },

  // Delete notification
  deleteNotification: async (notificationId: string): Promise<void> => {
    await axiosClient.delete(`/notifications/${notificationId}`);
  },

  // Get notification preferences
  getPreferences: async (): Promise<any> => {
    const response = await axiosClient.get('/notifications/preferences');
    return response.data;
  },

  // Update notification preferences
  updatePreferences: async (preferences: any): Promise<any> => {
    const response = await axiosClient.put('/notifications/preferences', preferences);
    return response.data;
  },
};
